import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./FireWatch.css";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import * as XLSX from "xlsx";

const SubMeter = ({ userRole }) => {
  const [subMeterJobs, setSubMeterJobs] = useState([]); // renamed from fireWatchJobs
  const [users, setUsers] = useState([]);
  const [properties, setProperties] = useState([]);
  const [propertyAddresses, setPropertyAddresses] = useState([]); // NEW
  const [searchTerm, setSearchTerm] = useState("");
const [expandedSites, setExpandedSites] = useState({}); // { [siteName]: true/false }

const [newAddressFirstName, setNewAddressFirstName] = useState("");
const [newAddressLastName, setNewAddressLastName] = useState("");


  // SELECT PROPERTY (job create)
  const [newJob, setNewJob] = useState({
    propertyId: "",
    siteName: "",
    addressId: "",
    addressLabel: "",
    firstReadingDate: "", // date of first reading
    meterType: "",
    notes: "",
  });

  // ADD READING (patrol popup)
  const [newReading, setNewReading] = useState({
    date: "", // date of last reading
    usGallonsWhole: "", // 0,000,xxx (NO decimals)
    x100: "", // one digit
    x10: "",
    x1: "",
    x01: "",  // x0.1
    x001: "", // x0.01
    techAssigned: "",
    fileUpload: [],
  });

  const [newAddressText, setNewAddressText] = useState("");

  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedReading, setSelectedReading] = useState(null); // used for edit
  const [isEditing, setIsEditing] = useState(false);
  const [editedReading, setEditedReading] = useState({});

  const [showAddJobPopup, setShowAddJobPopup] = useState(false); // Select Property
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [showReadingPopup, setShowReadingPopup] = useState(false); // Add Reading
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const [isUploading, setIsUploading] = useState(false);

  const storage = getStorage();

  // -------------------- HELPERS --------------------
  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${month}-${day}-${year}`;
  };

  const formatTotal = (num) => {
    const n = Number(num || 0);
    return n.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const isDigit = (v) => v !== "" && /^[0-9]$/.test(String(v));
  const safeDigit = (v) => (isDigit(v) ? Number(v) : 0);

  // Total Reading = usGallonsWhole + decimals from reels
  // usGallonsWhole should be digits only (e.g. 0000123 for 0,000,123)
  // Total = whole + (x1*1)?? NO - you said X1 is its own reel, so X1 is ones place AFTER whole.
  // But your UX says: "US Gallons (0,000,xxx.xx), X100, X10, X1, X0.1, X0.01"
  // We'll interpret as:
  // - usGallonsWhole is the "0,000,xxx" portion (whole gallons)
  // - x100 is hundreds place (0-9) -> + digit*100
  // - x10 is tens place -> + digit*10
  // - x1 is ones place -> + digit*1
  // - x0.1 and x0.01 are decimals
  const calcTotalReading = (r) => {
    // US Gallons = X1000 reel
    const thousands =
      Number(String(r.usGallonsWhole || "0").replace(/[^0-9]/g, "")) || 0;
  
    const total =
      thousands * 1000 +              // 🔥 FIX
      safeDigit(r.x100) * 100 +
      safeDigit(r.x10) * 10 +
      safeDigit(r.x1) * 1 +
      safeDigit(r.x01) * 0.1 +
      safeDigit(r.x001) * 0.01;
  
    return Math.round(total * 100) / 100;
  };
  

  // Finds previous reading (by date) within selectedJob.logs
  const getPreviousReading = (job, currentDate) => {
    const all = [];
    Object.values(job.logs || {}).forEach((day) => {
      (day.readings || []).forEach((rd) => all.push(rd));
    });

    // sort by date asc
    all.sort((a, b) => (a.date || "").localeCompare(b.date || ""));

    let prev = null;
    for (const rd of all) {
      if ((rd.date || "") < currentDate) prev = rd;
      else break;
    }
    return prev;
  };

  const recalcLogs = (logs, firstReadingDate) => {
    const all = [];
  
    Object.values(logs || {}).forEach((day) => {
      (day.readings || []).forEach((rd) => all.push({ ...rd }));
    });
  
    all.sort((a, b) => (a.date || "").localeCompare(b.date || ""));
  
    let prev = null;
    const rebuilt = {};
  
    all.forEach((rd) => {
      const prevTotal = prev ? Number(prev.totalReading) : null;
      const currTotal = Number(rd.totalReading);
  
      const gallonsUsed =
        prev && currTotal > prevTotal
          ? Math.round((currTotal - prevTotal) * 100) / 100
          : 0;
  
      const updated = {
        ...rd,
        gallonsUsed,
        fromDate: prev?.date || firstReadingDate || "",
        toDate: rd.date,
      };
  
      if (!rebuilt[rd.date]) {
        rebuilt[rd.date] = { date: rd.date, readings: [] };
      }
  
      rebuilt[rd.date].readings.push(updated);
      prev = updated;
    });
  
    return rebuilt;
  };

  const logDeletedReading = async ({
    job,
    reading,
    currentUser,
  }) => {
    const payload = {
      action: "DELETE_READING",
  
      siteName: job.siteName,
      propertyId: job.propertyId,
      addressId: job.addressId,
      addressLabel: job.addressLabel,
      subMeterJobId: job.id,
  
      deletedBy: {
        userId: currentUser?.id || "",
        name: currentUser
          ? `${currentUser.firstName} ${currentUser.lastName}`
          : "Unknown",
        role: currentUser?.role || "",
      },
  
      deletedAt: serverTimestamp(),
  
      reading: {
        ...reading,
      },
    };
  
    await addDoc(collection(db, "subMeterAuditLogs"), payload);
  };
  
  
  // -------------------- FILE UPLOAD --------------------
  const uploadFiles = async (files, pathPrefix) => {
    const uploaded = [];
    setIsUploading(true);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const storageRef = ref(storage, `${pathPrefix}/${Date.now()}_${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      uploaded.push(url);
    }

    setIsUploading(false);
    return uploaded;
  };

  const handleFileUploadForReading = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;

    const prefix = `subMeters/${selectedJob?.siteName || "site"}/${selectedJob?.addressLabel || "address"}`;
    const uploaded = await uploadFiles(files, prefix);

    setNewReading((prev) => ({ ...prev, fileUpload: [...(prev.fileUpload || []), ...uploaded] }));
  };

  const handleFileUploadForEdit = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;

    const prefix = `subMeters/${selectedJob?.siteName || "site"}/${selectedJob?.addressLabel || "address"}`;
    const uploaded = await uploadFiles(files, prefix);

    setEditedReading((prev) => ({ ...prev, fileUpload: [...(prev.fileUpload || []), ...uploaded] }));
  };

  const handleDeleteFile = async (fileURL, mode = "edit") => {
    try {
      const fileRef = ref(storage, fileURL);
      await deleteObject(fileRef);

      if (mode === "edit") {
        setEditedReading((prev) => ({
          ...prev,
          fileUpload: (prev.fileUpload || []).filter((u) => u !== fileURL),
        }));
      } else {
        setNewReading((prev) => ({
          ...prev,
          fileUpload: (prev.fileUpload || []).filter((u) => u !== fileURL),
        }));
      }
    } catch (err) {
      console.error("Error deleting file:", err);
    }
  };

  // -------------------- FETCH --------------------
  useEffect(() => {
    const fetchAll = async () => {
      try {
        // subMeters jobs
        const subRef = collection(db, "subMeters");
        const subSnap = await getDocs(subRef);
        const subList = subSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setSubMeterJobs(subList);

        // users
        const usersRef = collection(db, "users");
        const usersSnap = await getDocs(usersRef);
        setUsers(usersSnap.docs.map((d) => ({ id: d.id, ...d.data() })));

        // properties
        const propertiesRef = collection(db, "properties");
        const propsSnap = await getDocs(propertiesRef);
        const propsList = propsSnap.docs.map((d) => ({
          id: d.id,
          propertyName: d.data().propertyName,
          ...d.data(),
        }));
        propsList.sort((a, b) => a.propertyName.localeCompare(b.propertyName));
        setProperties(propsList);

        // addresses
        const addrRef = collection(db, "propertiesAddresses");
const addrSnap = await getDocs(addrRef);

const addrList = addrSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

// sort by siteName then addressLabel
addrList.sort((a, b) => {
  const s = (a.siteName || "").localeCompare(b.siteName || "");
  if (s !== 0) return s;
  return (a.addressLabel || "").localeCompare(b.addressLabel || "");
});

setPropertyAddresses(addrList);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchAll();
  }, []);

  // Addresses filtered by selected property in newJob
  const filteredAddresses = propertyAddresses
  .filter((a) => a.propertyId === newJob.propertyId)
  .slice()
  .sort((a, b) => (a.addressLabel || "").localeCompare(b.addressLabel || ""));


  // -------------------- HANDLERS: JOB CREATE --------------------
  const handleJobChange = (e) => {
    const { name, value } = e.target;

    if (name === "propertyId") {
      const prop = properties.find((p) => p.id === value);
      setNewJob((prev) => ({
        ...prev,
        propertyId: value,
        siteName: prop?.propertyName || "",
        addressId: "",
        addressLabel: "",
      }));
      return;
    }

    if (name === "addressId") {
      const addr = propertyAddresses.find((a) => a.id === value);
      setNewJob((prev) => ({
        ...prev,
        addressId: value,
        addressLabel: addr?.addressLabel || "",
      }));
      return;
    }

    setNewJob((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddAddress = async () => {
    if (!newJob.propertyId || !newJob.siteName) {
      alert("Select a Site Name first.");
      return;
    }
    if (!newAddressText.trim()) {
      alert("Enter an address to add.");
      return;
    }

    const payload = {
      propertyId: newJob.propertyId,
      siteName: newJob.siteName,
      addressLabel: newAddressText.trim(),
      firstName: newAddressFirstName.trim() || "",
      lastName: newAddressLastName.trim() || "",
      createdAt: new Date(),
    };

    setNewAddressText("");
setNewAddressFirstName("");
setNewAddressLastName("");

    

    try {
      const docRef = await addDoc(collection(db, "propertiesAddresses"), payload);
      const created = { id: docRef.id, ...payload };

      setPropertyAddresses((prev) => [...prev, created]);

      // auto-select it
      setNewJob((prev) => ({
        ...prev,
        addressId: created.id,
        addressLabel: created.addressLabel,
      }));

    } catch (err) {
      console.error("Add address error:", err);
    }
  };

  const handleAddSubMeterJob = async () => {
    const mandatory = ["propertyId", "addressId", "firstReadingDate"];
    for (const f of mandatory) {
      if (!newJob[f]) {
        alert(`Please fill out: ${f}`);
        return;
      }
    }

    try {
      const payload = {
        ...newJob,
        logs: {}, // readings will be stored here
        createdAt: new Date(),
      };

      const docRef = await addDoc(collection(db, "subMeters"), payload);
      setSubMeterJobs((prev) => [...prev, { id: docRef.id, ...payload }]);

      setShowAddJobPopup(false);
      setNewJob({
        propertyId: "",
        siteName: "",
        addressId: "",
        addressLabel: "",
        firstReadingDate: "",
        meterType: "",
        notes: "",
      });

      alert("Sub Meter record created.");
    } catch (err) {
      console.error("Add sub meter job error:", err);
    }
  };

  // -------------------- HANDLERS: ADD READING (PATROL) --------------------
  const handleReadingChange = (e) => {
    const { name, value } = e.target;
    // allow commas in usGallonsWhole, but store as string
    setNewReading((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddReading = async () => {
    if (!selectedJob) return;

    const mandatory = ["date", "usGallonsWhole"];
    for (const f of mandatory) {
      if (!newReading[f]) {
        alert(`Please fill out: ${f}`);
        return;
      }
    }

    const digitFields = ["x100", "x10", "x1", "x01", "x001"];
    for (const f of digitFields) {
      if (!isDigit(newReading[f])) {
        alert(`Please enter a single digit (0-9) for: ${f}`);
        return;
      }
    }

    if (isUploading) {
      alert("Files are still uploading. Please wait.");
      return;
    }

    const totalReading = calcTotalReading(newReading);
    const prev = getPreviousReading(selectedJob, newReading.date);

    const gallonsUsed = prev ? Math.round((totalReading - Number(prev.totalReading || 0)) * 100) / 100 : 0;
    const fromDate = prev?.date || selectedJob.firstReadingDate || "";
    const toDate = newReading.date;

    const readingObj = {
      date: newReading.date,
      usGallonsWhole: String(newReading.usGallonsWhole || ""),
      x100: safeDigit(newReading.x100),
      x10: safeDigit(newReading.x10),
      x1: safeDigit(newReading.x1),
      x01: safeDigit(newReading.x01),
      x001: safeDigit(newReading.x001),
      totalReading,
      gallonsUsed: gallonsUsed < 0 ? 0 : gallonsUsed,
      fromDate,
      toDate,
      techAssigned: newReading.techAssigned || "",
      fileUpload: newReading.fileUpload || [],
      createdAt: new Date(),
    };

    const dateKey = newReading.date;

    const updatedLogs = {
      ...(selectedJob.logs || {}),
      [dateKey]: {
        date: dateKey,
        readings: [
          ...((selectedJob.logs?.[dateKey]?.readings) || []),
          readingObj,
        ],
      },
    };

    try {
      const normalizedLogs = recalcLogs(updatedLogs, selectedJob.firstReadingDate);

await updateDoc(doc(db, "subMeters", selectedJob.id), {
  logs: normalizedLogs,
});


      // update local
      setSubMeterJobs((prev) =>
        prev.map((j) => (j.id === selectedJob.id ? { ...j, logs: updatedLogs } : j))
      );

      setSelectedJob((prev) => ({ ...prev, logs: updatedLogs }));

      setShowReadingPopup(false);
      setNewReading({
        date: "",
        usGallonsWhole: "",
        x100: "",
        x10: "",
        x1: "",
        x01: "",
        x001: "",
        techAssigned: "",
        fileUpload: [],
      });

      alert("Reading added.");
    } catch (err) {
      console.error("Add reading error:", err);
    }
  };

  // -------------------- DETAILS + EDIT --------------------
  const handleDetailsClick = (job) => {
    setSelectedJob(job);
    setShowDetailsPopup(true);
    setIsEditing(false);
    setSelectedReading(null);
  };

  const handleEditReadingClick = (reading) => {
    setIsEditing(true);
    setSelectedReading(reading);
    setEditedReading({ ...reading });
  };

  const handleEditReadingChange = (e) => {
    const { name, value } = e.target;
    setEditedReading((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateReading = async () => {
    if (!selectedJob || !selectedReading) return;

    if (isUploading) {
      alert("Files are still uploading. Please wait.");
      return;
    }

    const digitFields = ["x100", "x10", "x1", "x01", "x001"];
    for (const f of digitFields) {
      if (!isDigit(editedReading[f])) {
        alert(`Please enter a single digit (0-9) for: ${f}`);
        return;
      }
    }

    const totalReading = calcTotalReading(editedReading);

    // Build a flattened list of readings excluding this one, then recompute prev for edited date
    const all = [];
    Object.values(selectedJob.logs || {}).forEach((day) => {
      (day.readings || []).forEach((rd) => {
        if (!(rd.date === selectedReading.date && rd.createdAt?.seconds === selectedReading.createdAt?.seconds)) {
          all.push(rd);
        }
      });
    });
    all.sort((a, b) => (a.date || "").localeCompare(b.date || ""));
    let prev = null;
    for (const rd of all) {
      if ((rd.date || "") < editedReading.date) prev = rd;
      else break;
    }

    const gallonsUsed = prev ? Math.round((totalReading - Number(prev.totalReading || 0)) * 100) / 100 : 0;
    const fromDate = prev?.date || selectedJob.firstReadingDate || "";
    const toDate = editedReading.date;

    // Replace in logs
    const newLogs = { ...(selectedJob.logs || {}) };

    // remove old entry
    Object.keys(newLogs).forEach((k) => {
      newLogs[k].readings = (newLogs[k].readings || []).filter(
        (rd) => !(rd === selectedReading)
      );
      if ((newLogs[k].readings || []).length === 0) delete newLogs[k];
    });

    const updatedReading = {
      ...editedReading,
      usGallonsWhole: String(editedReading.usGallonsWhole || ""),
      x100: safeDigit(editedReading.x100),
      x10: safeDigit(editedReading.x10),
      x1: safeDigit(editedReading.x1),
      x01: safeDigit(editedReading.x01),
      x001: safeDigit(editedReading.x001),
      totalReading,
      gallonsUsed: gallonsUsed < 0 ? 0 : gallonsUsed,
      fromDate,
      toDate,
      fileUpload: editedReading.fileUpload || [],
    };

    const dateKey = editedReading.date;
    newLogs[dateKey] = {
      date: dateKey,
      readings: [...(newLogs[dateKey]?.readings || []), updatedReading],
    };

    try {
      const normalizedLogs = recalcLogs(newLogs, selectedJob.firstReadingDate);

await updateDoc(doc(db, "subMeters", selectedJob.id), {
  logs: normalizedLogs,
});

      setSubMeterJobs((prev) =>
        prev.map((j) => (j.id === selectedJob.id ? { ...j, logs: newLogs } : j))
      );
      setSelectedJob((prev) => ({ ...prev, logs: newLogs }));

      setIsEditing(false);
      setSelectedReading(null);
      alert("Reading updated.");
    } catch (err) {
      console.error("Update reading error:", err);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setSelectedReading(null);
  };

  // -------------------- DELETE JOB --------------------
  const handleDeleteConfirmation = () => setShowDeleteConfirmation(true);

  const confirmDelete = async () => {
    try {
      const jobDoc = doc(db, "subMeters", selectedJob.id);
      await deleteDoc(jobDoc);
      setSubMeterJobs(subMeterJobs.filter((j) => j.id !== selectedJob.id));
      setShowDetailsPopup(false);
      setSelectedJob(null);
      setShowDeleteConfirmation(false);
    } catch (err) {
      console.error("Error deleting sub meter job:", err);
    }
  };

  const cancelDelete = () => setShowDeleteConfirmation(false);

  const handleDeleteReading = async (readingToDelete) => {
    if (!selectedJob) return;
  
    const ok = window.confirm(
      "Are you sure you want to delete this reading? This action is logged and cannot be undone."
    );
    if (!ok) return;
  
    try {
      // 🔐 1. AUDIT LOG (WRITE FIRST)
      await logDeletedReading({
        job: selectedJob,
        reading: readingToDelete,
        currentUser: users.find(u => u.role === userRole) || null,
      });
  
      // 🧹 2. REMOVE READING
      const newLogs = { ...(selectedJob.logs || {}) };
  
      Object.keys(newLogs).forEach((dateKey) => {
        newLogs[dateKey].readings = (newLogs[dateKey].readings || []).filter(
          (rd) =>
            !(
              rd.date === readingToDelete.date &&
              rd.createdAt?.seconds === readingToDelete.createdAt?.seconds
            )
        );
  
        if (newLogs[dateKey].readings.length === 0) {
          delete newLogs[dateKey];
        }
      });
  
      // 🔁 3. NORMALIZE
      const normalizedLogs = recalcLogs(
        newLogs,
        selectedJob.firstReadingDate
      );
  
      // 💾 4. SAVE
      await updateDoc(doc(db, "subMeters", selectedJob.id), {
        logs: normalizedLogs,
      });
  
      // 🧠 5. LOCAL STATE
      setSubMeterJobs((prev) =>
        prev.map((j) =>
          j.id === selectedJob.id ? { ...j, logs: normalizedLogs } : j
        )
      );
  
      setSelectedJob((prev) => ({ ...prev, logs: normalizedLogs }));
  
      alert("Reading deleted and audit logged.");
    } catch (err) {
      console.error("Delete reading error:", err);
      alert("Failed to delete reading. See console.");
    }
  };
  
  
  // -------------------- EXCEL (IN DETAILS POPUP ONLY) --------------------
  const downloadExcel = (job) => {
    const rows = [];

    rows.push({
      Site: job.siteName,
      Address: job.addressLabel,
      FirstReadingDate: job.firstReadingDate,
      MeterType: job.meterType || "",
      Notes: job.notes || "",
    });

    const all = [];
    Object.values(job.logs || {}).forEach((day) => {
      (day.readings || []).forEach((rd) => all.push(rd));
    });

    all.sort((a, b) => (a.date || "").localeCompare(b.date || ""));

    all.forEach((rd) => {
      rows.push({
        Site: "",
        Address: "",
        ReadingDate: formatDate(rd.date),
        TotalReading: formatTotal(rd.totalReading),
        GallonsUsed: rd.gallonsUsed,
        FromDate: rd.fromDate ? formatDate(rd.fromDate) : "",
        ToDate: rd.toDate ? formatDate(rd.toDate) : "",
        Tech: rd.techAssigned || "",
        Files: (rd.fileUpload || []).join(" | "),
      });
    });

    const ws = XLSX.utils.json_to_sheet(rows, { skipHeader: false });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sub Meter Readings");

    XLSX.writeFile(wb, `SubMeter_${job.siteName}_${job.addressLabel}.xlsx`);
  };

  // -------------------- MODALS --------------------
  const closeModal = () => {
    setShowAddJobPopup(false);
    setShowDetailsPopup(false);
    setShowReadingPopup(false);
    setShowDeleteConfirmation(false);
    setSelectedJob(null);
    setIsEditing(false);
    setSelectedReading(null);
    setEditedReading({});
    setNewReading({
      date: "",
      usGallonsWhole: "",
      x100: "",
      x10: "",
      x1: "",
      x01: "",
      x001: "",
      techAssigned: "",
      fileUpload: [],
    });
  };

  const handleAddReadingClick = (job) => {
    setSelectedJob(job);
    setShowReadingPopup(true);
    setNewReading({
      date: "",
      usGallonsWhole: "",
      x100: "",
      x10: "",
      x1: "",
      x01: "",
      x001: "",
      techAssigned: "",
      fileUpload: [],
    });
  };

  const handlePrint = () => window.print();

  // Flatten readings for display in details
  const flattenReadings = (job) => {
    const all = [];
    Object.values(job.logs || {}).forEach((day) => {
      (day.readings || []).forEach((rd) => all.push(rd));
    });
    all.sort((a, b) => (b.date || "").localeCompare(a.date || ""));
    return all;
  };

  const addrById = propertyAddresses.reduce((acc, a) => {
    acc[a.id] = a;
    return acc;
  }, {});
  
  const normalize = (s) => String(s || "").toLowerCase().trim();
  
  const matchesSearch = (job) => {
    const a = addrById[job.addressId] || {};
    const term = normalize(searchTerm);
    if (!term) return true;
  
    const site = normalize(job.siteName);
    const addr = normalize(job.addressLabel);
    const fn = normalize(a.firstName);
    const ln = normalize(a.lastName);
  
    return (
      site.includes(term) ||
      addr.includes(term) ||
      fn.includes(term) ||
      ln.includes(term) ||
      `${fn} ${ln}`.includes(term)
    );
  };
  
  const jobsFiltered = subMeterJobs.filter(matchesSearch);
  
  // group by siteName
  const groupedBySite = jobsFiltered.reduce((acc, job) => {
    const key = job.siteName || "Unknown Site";
    if (!acc[key]) acc[key] = [];
    acc[key].push(job);
    return acc;
  }, {});
  
  // sort site names
  const siteNames = Object.keys(groupedBySite).sort((a, b) => a.localeCompare(b));
  
  // sort jobs under each site by addressLabel A-Z
  siteNames.forEach((sn) => {
    groupedBySite[sn].sort((a, b) => (a.addressLabel || "").localeCompare(b.addressLabel || ""));
  });
  
  const toggleSite = (siteName) => {
    setExpandedSites((prev) => ({ ...prev, [siteName]: !prev[siteName] }));
  };
  
  // Address name for DETAILS popup (optional)
const selectedAddr = selectedJob
? propertyAddresses.find((a) => a.id === selectedJob.addressId)
: null;

const selectedAddrName = selectedAddr
? `${selectedAddr.firstName || ""} ${selectedAddr.lastName || ""}`.trim()
: "";


  return (
    <div className="firewatch-page">
      <h1>Sub Meter</h1>

      {/* Button renamed per your flow */}
      <button className="blue-button" onClick={() => setShowAddJobPopup(true)}>
        Select Property
      </button>

      {/* SELECT PROPERTY POPUP */}
      {showAddJobPopup && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Select Property</h2>
            <div className="form-grid">
              <div>
                <label>Site Name <span className="required">*</span></label>
                <select name="propertyId" onChange={handleJobChange} value={newJob.propertyId}>
                  <option value="">Select Site</option>
                  {properties.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.propertyName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label>Address <span className="required">*</span></label>
                <select name="addressId" onChange={handleJobChange} value={newJob.addressId} disabled={!newJob.propertyId}>
                  <option value="">{newJob.propertyId ? "Select Address" : "Select Site first"}</option>
                  {filteredAddresses.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.addressLabel}
                    </option>
                  ))}
                </select>

                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
  <input
    placeholder="Add new address"
    value={newAddressText}
    onChange={(e) => setNewAddressText(e.target.value)}
    disabled={!newJob.propertyId}
  />
  <button className="blue-button" type="button" onClick={handleAddAddress} disabled={!newJob.propertyId}>
    Add Address
  </button>
</div>

<div style={{ display: "flex", gap: 8, marginTop: 8 }}>
  <input
    placeholder="First Name (optional)"
    value={newAddressFirstName}
    onChange={(e) => setNewAddressFirstName(e.target.value)}
    disabled={!newJob.propertyId}
  />
  <input
    placeholder="Last Name (optional)"
    value={newAddressLastName}
    onChange={(e) => setNewAddressLastName(e.target.value)}
    disabled={!newJob.propertyId}
  />
</div>
</div>


              <div>
                <label>Date of First Reading <span className="required">*</span></label>
                <input type="date" name="firstReadingDate" onChange={handleJobChange} value={newJob.firstReadingDate} />
              </div>

              <div>
                <label>Type of Sub Meter</label>
                <input name="meterType" onChange={handleJobChange} value={newJob.meterType} />
              </div>

              <div>
                <label>Notes</label>
                <input name="notes" onChange={handleJobChange} value={newJob.notes} />
              </div>
            </div>

            <div className="modal-buttons">
              <button className="blue-button" onClick={handleAddSubMeterJob}>
                Save
              </button>
              <button className="red-button" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DETAILS POPUP */}
      {showDetailsPopup && selectedJob && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Sub Meter Details</h2>
            <div className="popup-content">
              <p><strong>Site Name:</strong> {selectedJob.siteName}</p>
              {selectedAddrName && (
  <p><strong>Name:</strong> {selectedAddrName}</p>
)}

              <p><strong>Address:</strong> {selectedJob.addressLabel}</p>
              <p><strong>Date of First Reading:</strong> {formatDate(selectedJob.firstReadingDate)}</p>
              <p><strong>Meter Type:</strong> {selectedJob.meterType || ""}</p>
              <p><strong>Notes:</strong> {selectedJob.notes || ""}</p>

              <h4>Readings</h4>

              {!isEditing && (
                <>
                  {flattenReadings(selectedJob).map((rd, idx) => (
                    <div key={idx} className="patrol-row">
                      <p><strong>Reading Date:</strong><br />{formatDate(rd.date)}</p>
                      <p><strong>Total Reading:</strong><br />{formatTotal(rd.totalReading)}</p>
                      <p>
                        <strong>Gallons Used:</strong><br />
                        {rd.gallonsUsed} <br />
                        <span style={{ fontSize: 12 }}>
                          ({rd.fromDate ? formatDate(rd.fromDate) : ""} → {rd.toDate ? formatDate(rd.toDate) : ""})
                        </span>
                      </p>
                      <p><strong>Tech Assigned:</strong><br />{rd.techAssigned || ""}</p>

                      {Array.isArray(rd.fileUpload) && rd.fileUpload.length > 0 && (
                        <p>
                          <strong>File Upload:</strong>{" "}
                          {rd.fileUpload.map((file, i) => (
                            <a key={i} href={file} target="_blank" rel="noopener noreferrer">
                              File {i + 1}
                            </a>
                          ))}
                        </p>
                      )}

<button className="blue-button" onClick={() => handleEditReadingClick(rd)}>
  Edit
</button>
<button className="red-button" onClick={() => handleDeleteReading(rd)}>
  Delete Reading
</button>

                    </div>
                  ))}

                  <div className="modal-buttons">
                    <button className="red-button" onClick={handleDeleteConfirmation}>Delete</button>
                    <button className="green-button" onClick={closeModal}>Close</button>
                    <button className="blue-button" onClick={handlePrint}>Print</button>
                    <button className="blue-button" onClick={() => downloadExcel(selectedJob)}>
                      Download Excel
                    </button>
                  </div>
                </>
              )}

              {isEditing && (
                <div className="form-grid">
                  <div>
                    <label>Date of Last Reading</label>
                    <input type="date" name="date" value={editedReading.date || ""} onChange={handleEditReadingChange} />
                  </div>

                  <div>
                    <label>US Gallons (X1000)</label>
                    <input name="usGallonsWhole" value={editedReading.usGallonsWhole || ""} onChange={handleEditReadingChange} />
                  </div>

                  <div>
                    <label>X100</label>
                    <input name="x100" maxLength={1} value={editedReading.x100 ?? ""} onChange={handleEditReadingChange} />
                  </div>
                  <div>
                    <label>X10</label>
                    <input name="x10" maxLength={1} value={editedReading.x10 ?? ""} onChange={handleEditReadingChange} />
                  </div>
                  <div>
                    <label>X1</label>
                    <input name="x1" maxLength={1} value={editedReading.x1 ?? ""} onChange={handleEditReadingChange} />
                  </div>
                  <div>
                    <label>X0.1</label>
                    <input name="x01" maxLength={1} value={editedReading.x01 ?? ""} onChange={handleEditReadingChange} />
                  </div>
                  <div>
                    <label>X0.01</label>
                    <input name="x001" maxLength={1} value={editedReading.x001 ?? ""} onChange={handleEditReadingChange} />
                  </div>

                  <div>
                    <label>Tech Assigned</label>
                    <select name="techAssigned" value={editedReading.techAssigned || ""} onChange={handleEditReadingChange}>
                      <option value="">Select Tech</option>
                      {users.map((u) => (
                        <option key={u.id} value={`${u.firstName} ${u.lastName}`}>
                          {u.firstName} {u.lastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label>File Upload</label>
                    <input type="file" multiple accept=".pdf,.jpeg,.jpg,.png,.xlsx" onChange={handleFileUploadForEdit} />
                    {Array.isArray(editedReading.fileUpload) && editedReading.fileUpload.map((file, i) => (
                      <div key={i} className="file-item">
                        <a href={file} target="_blank" rel="noopener noreferrer">File {i + 1}</a>
                        <button className="delete-button" onClick={() => handleDeleteFile(file, "edit")}>X</button>
                      </div>
                    ))}
                  </div>

                  <div className="modal-buttons">
                    <button className="blue-button" onClick={handleUpdateReading} disabled={isUploading}>
                      {isUploading ? "Uploading..." : "Update"}
                    </button>
                    <button className="red-button" onClick={handleCancelEdit}>Cancel</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ADD READING POPUP (PATROL) */}
      {showReadingPopup && selectedJob && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Add Reading</h2>
            <div className="form-grid">
              <div>
                <label>Date of Last Reading</label>
                <input type="date" name="date" value={newReading.date} onChange={handleReadingChange} />
              </div>

              <div>
                <label>US Gallons (X1000)</label>
                <input name="usGallonsWhole" value={newReading.usGallonsWhole} onChange={handleReadingChange} />
              </div>

              <div>
                <label>X100</label>
                <input name="x100" maxLength={1} value={newReading.x100} onChange={handleReadingChange} />
              </div>
              <div>
                <label>X10</label>
                <input name="x10" maxLength={1} value={newReading.x10} onChange={handleReadingChange} />
              </div>
              <div>
                <label>X1</label>
                <input name="x1" maxLength={1} value={newReading.x1} onChange={handleReadingChange} />
              </div>
              <div>
                <label>X0.1</label>
                <input name="x01" maxLength={1} value={newReading.x01} onChange={handleReadingChange} />
              </div>
              <div>
                <label>X0.01</label>
                <input name="x001" maxLength={1} value={newReading.x001} onChange={handleReadingChange} />
              </div>

              <div>
                <label>Tech Assigned</label>
                <select name="techAssigned" value={newReading.techAssigned} onChange={handleReadingChange}>
                  <option value="">Select Tech</option>
                  {users.map((u) => (
                    <option key={u.id} value={`${u.firstName} ${u.lastName}`}>
                      {u.firstName} {u.lastName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label>File Upload</label>
                <input type="file" multiple accept=".pdf,.jpeg,.jpg,.png,.xlsx" onChange={handleFileUploadForReading} />
                {Array.isArray(newReading.fileUpload) && newReading.fileUpload.map((file, i) => (
                  <div key={i} className="file-item">
                    <a href={file} target="_blank" rel="noopener noreferrer">File {i + 1}</a>
                    <button className="delete-button" onClick={() => handleDeleteFile(file, "new")}>X</button>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-buttons">
              <button className="blue-button" onClick={handleAddReading} disabled={isUploading}>
                {isUploading ? "Uploading..." : "Save"}
              </button>
              <button className="red-button" onClick={closeModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRMATION */}
      {showDeleteConfirmation && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Are you sure you want to delete this Sub Meter record?</h2>
            <div className="modal-buttons">
              <button className="red-button" onClick={confirmDelete}>Yes</button>
              <button className="blue-button" onClick={cancelDelete}>No</button>
            </div>
          </div>
        </div>
      )}

      {/* MAIN LIST */}
      <h2>Sub Meter List</h2>
      <div style={{ margin: "10px 0" }}>
  <input
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder="Search site name, address, or name..."
    style={{ width: "100%", maxWidth: 520 }}
  />
</div>

      <table className="firewatch-table">
        <thead>
          <tr>
            <th>Site Name</th>
            <th>Address</th>
            <th>Date of First Reading</th>
            <th>Add Reading</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
  {siteNames.length === 0 ? (
    <tr>
      <td colSpan={5} style={{ textAlign: "center", padding: 12 }}>
        No results found.
      </td>
    </tr>
  ) : (
    siteNames.map((site) => {
      const isOpen = !!expandedSites[site];
      const jobs = groupedBySite[site];

      return (
        <React.Fragment key={site}>
          {/* Site header row */}
          <tr
            style={{ cursor: "pointer", fontWeight: 700 }}
            onClick={() => toggleSite(site)}
          >
            <td>
              {isOpen ? "▼" : "▶"} {site}
            </td>
            <td colSpan={4}>
              {jobs.length} address{jobs.length === 1 ? "" : "es"}
            </td>
          </tr>

          {/* Expanded job rows */}
          {isOpen &&
            jobs.map((job) => (
              <tr key={job.id}>
                <td style={{ paddingLeft: 28 }}>{job.siteName}</td>
                <td>{job.addressLabel}</td>
                <td>{job.firstReadingDate}</td>
                <td>
                  <button className="blue-button" onClick={() => handleAddReadingClick(job)}>
                    Add Reading
                  </button>
                </td>
                <td>
                  <button className="blue-button" onClick={() => handleDetailsClick(job)}>
                    Details
                  </button>
                </td>
              </tr>
            ))}
        </React.Fragment>
      );
    })
  )}
</tbody>

      </table>
    </div>
  );
};

export default SubMeter;
